// extracted by mini-css-extract-plugin
export default {"auto-notification":"AutoNotification_auto-notification__9cPxZ","auto-notification__input":"AutoNotification_auto-notification__input__44KcA"};